module.exports = __webpack_public_path__ + "static/media/Domestic-Solutions-Blog-Header-Full-size.287a40da.png";